import { SortOptions } from '@/components/datatable/use-column-sort'

export interface DataTableColumn {
  name: string
  label: string
  sortable: boolean
  sortBy?: string
  translation?: string
  alignLabel?: AlignLabelOption
  alignContent?: AlignLabelOption
  secondary?: boolean
  width?: number
}

export enum AlignLabelOption {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}

export type DataTableSlotRow<T> = {
  row: T
}

export enum SelectAllBehavior {
  AllInPage = 'AllInPage',
  AllData = 'AllData',
}

export interface GenericDataType {
  id: number
  [key: string]: string | number
}

export enum SelectAllState {
  All,
  Some,
  None,
}

export interface DataTableProps<DataType> {
  columns: DataTableColumn[]
  data: DataType[]
  page: number
  pageSize: number
  sortOptions?: SortOptions | null
  totalResults: number
  isLoading?: boolean
  showFixedHeader?: boolean
  rowSelection?: number[]
  rowDisableSelection?: number[]
  enableRowSelection?: boolean
  showPagination?: boolean
  showResults?: boolean
  showPageSizeSelector?: boolean
  expandedItemId?: number | null
  enableExpandAction?: boolean
  condensed?: boolean
  tooltipDisableCheckbox?: string
  rowClass?: string
  enableSingleSelection?: boolean
  expandableColumnWidth?: number | null
  keepVisibleSelectedItems?: boolean
  selectedItems?: Set<DataType>
  mainSectionClass?: string
  tableClass?: string
  paginationClass?: string
  containerClass?: string
  selectAllBehavior?: SelectAllBehavior
  rowSelectionLimit?: number
}
